import { useState,useEffect } from 'react';
import utils from "../utils";
export default function useDownLoad() {
  const [iosLink, setIosLink] = useState('');
  const [andLink, setAndLink] = useState('');

  useEffect(()=>{
    if(utils.IsPC()){
      setIosLink('https://itunes.apple.com/app/dingtone-free-phone-calls/id588937297?mt=8')
      setAndLink('https://play.google.com/store/apps/details?id=me.dingtone.app.im')
    } else {
      setIosLink('https://app.adjust.com/k37q0rh')
      setAndLink('https://app.adjust.com/nrzsj8p')
    }
  })
  return {
    iosLink,
    andLink,
  };
}